// import { useState } from "react";

// const VideoGallery = () => {
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Replace these with your actual video URLs (MP4 or streaming URLs)
//   const galleryVideos = [
//     "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758598020/GOLF_VIDEO_FINAL_phpxne.mp4",
//     "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758578190/BREAKFAST_CUP_GOLF_TOURNAMENT_uggxmo.mp4",
//     "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758578172/PRESIDENT_CUP_GOLF_TOURNAMENT_dtspjh.mp4",
//     "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758908730/GOLF_0123_mynfhj.mp4",
//     "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758908734/GOLF_0124_nch0o0.mp4",
//     // add more video URLs here...
//   ];

//   // Optional: thumbnail URLs (if you have custom thumbnails), else can use poster from video tag or generate
//   const videoThumbnails = [
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758602373/rgcc_thumb_givhqh_ii5qu5.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758602259/breakfast_golf_cup_tournament_csiakt_qwqttp.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758602079/president_cup_golf_up_tournament_h1cn9m_t0qkvc.jpg",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758908705/GOLF_0123_thumb-min_b9wp8h.png",
//     "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758908705/GOLF_0124_thumb-min_wjhseg.png",
//     // match order with galleryVideos or leave blank to fallback
//   ];

//   const openLightbox = (index) => {
//     setSelectedVideo(galleryVideos[index]);
//     setCurrentIndex(index);
//   };

//   const closeLightbox = () => {
//     setSelectedVideo(null);
//   };

//   const navigateVideo = (direction) => {
//     let newIndex;
//     if (direction === "prev") {
//       newIndex =
//         (currentIndex - 1 + galleryVideos.length) % galleryVideos.length;
//     } else {
//       newIndex = (currentIndex + 1) % galleryVideos.length;
//     }
//     setCurrentIndex(newIndex);
//     setSelectedVideo(galleryVideos[newIndex]);
//   };

//   return (
//     <section className="py-16 px-4 md:px-20 bg-white">
//       <h2 className="text-3xl font-bold text-center mb-12 uppercase">
//         RGCC Video Gallery
//       </h2>

//       <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
//         {galleryVideos.map((videoUrl, index) => (
//           <div
//             key={index}
//             className="relative mb-4 cursor-pointer group inline-block"
//             onClick={() => openLightbox(index)}
//           >
//             {/* Thumbnail image or fallback */}
//             <img
//               src={
//                 videoThumbnails[index] ||
//                 "https://via.placeholder.com/400x225?text=Video"
//               }
//               alt={`Video ${index + 1}`}
//               className="w-full h-auto block object-contain transition-transform duration-500 group-hover:scale-105"
//             />
//             {/* Play icon overlay */}
//             <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-all duration-300 rounded-md">
//               <svg
//                 className="w-16 h-16 text-white opacity-90"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M14.752 11.168l-6.518-3.758A1 1 0 007 8.242v7.516a1 1 0 001.234.97l6.518-3.758a1 1 0 000-1.742z"
//                 />
//               </svg>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Lightbox */}
//       {selectedVideo && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
//           <button
//             onClick={closeLightbox}
//             className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &times;
//           </button>

//           <button
//             onClick={() => navigateVideo("prev")}
//             className="absolute left-4 md:left-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10094;
//           </button>

//           <div className="max-w-4xl w-full">
//             <video
//               src={selectedVideo}
//               controls
//               autoPlay
//               className="w-full max-h-[80vh] object-contain rounded-md"
//             />
//           </div>

//           <button
//             onClick={() => navigateVideo("next")}
//             className="absolute right-4 md:right-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10095;
//           </button>

//           <div className="absolute bottom-4 text-white select-none">
//             {currentIndex + 1} / {galleryVideos.length}
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default VideoGallery;
// import { useState } from "react";

// const VideoGallery = () => {
//   const [selectedVideo, setSelectedVideo] = useState(null);
//   const [currentIndex, setCurrentIndex] = useState(0);

//   // Video URLs
//   const galleryVideos = [
// "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758598020/GOLF_VIDEO_FINAL_phpxne.mp4",
// "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758578190/BREAKFAST_CUP_GOLF_TOURNAMENT_uggxmo.mp4",
// "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758578172/PRESIDENT_CUP_GOLF_TOURNAMENT_dtspjh.mp4",
// "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758908730/GOLF_0123_mynfhj.mp4",
// "https://res.cloudinary.com/dxdvcplbl/video/upload/v1758908734/GOLF_0124_nch0o0.mp4",
//   ];

//   const openLightbox = (index) => {
//     setSelectedVideo(galleryVideos[index]);
//     setCurrentIndex(index);
//   };

//   const closeLightbox = () => setSelectedVideo(null);

//   const navigateVideo = (direction) => {
//     let newIndex;
//     if (direction === "prev") {
//       newIndex =
//         (currentIndex - 1 + galleryVideos.length) % galleryVideos.length;
//     } else {
//       newIndex = (currentIndex + 1) % galleryVideos.length;
//     }
//     setCurrentIndex(newIndex);
//     setSelectedVideo(galleryVideos[newIndex]);
//   };

//   return (
//     <section className="py-16 px-4 md:px-20 bg-white">
//       <h2 className="text-3xl font-bold text-center mb-12 uppercase">
//         RGCC Video Gallery
//       </h2>

//       {/* Direct video grid */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
//         {galleryVideos.map((videoUrl, index) => (
//           <div
//             key={index}
//             className="relative group cursor-pointer"
//             onClick={() => openLightbox(index)}
//           >
//             <video
//               src={videoUrl}
//               muted
//               loop
//               playsInline
//               className="w-full rounded-lg object-cover transition-transform duration-500 group-hover:scale-105"
//             />
//             <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-all duration-300 rounded-lg">
//               <svg
//                 className="w-16 h-16 text-white opacity-90"
//                 fill="none"
//                 stroke="currentColor"
//                 viewBox="0 0 24 24"
//               >
//                 <path
//                   strokeLinecap="round"
//                   strokeLinejoin="round"
//                   strokeWidth={2}
//                   d="M14.752 11.168l-6.518-3.758A1 1 0 007 8.242v7.516a1 1 0 001.234.97l6.518-3.758a1 1 0 000-1.742z"
//                 />
//               </svg>
//             </div>
//           </div>
//         ))}
//       </div>

//       {/* Lightbox */}
//       {selectedVideo && (
//         <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
//           <button
//             onClick={closeLightbox}
//             className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &times;
//           </button>

//           <button
//             onClick={() => navigateVideo("prev")}
//             className="absolute left-4 md:left-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10094;
//           </button>

//           <div className="max-w-4xl w-full">
//             <video
//               src={selectedVideo}
//               controls
//               autoPlay
//               className="w-full max-h-[80vh] object-contain rounded-md"
//             />
//           </div>

//           <button
//             onClick={() => navigateVideo("next")}
//             className="absolute right-4 md:right-10 text-white text-4xl hover:text-gray-300 transition-colors"
//           >
//             &#10095;
//           </button>

//           <div className="absolute bottom-4 text-white select-none">
//             {currentIndex + 1} / {galleryVideos.length}
//           </div>
//         </div>
//       )}
//     </section>
//   );
// };

// export default VideoGallery;

import { useState, useEffect } from "react";
import api from "../api/axiosInstance";

// const BACKEND_URL = "http://localhost:8081";
// const BACKEND_URL = "https://api.rangpurgolf.com";

const VideoGallery = () => {
  const [galleryVideos, setGalleryVideos] = useState([]);
  const [selectedVideo, setSelectedVideo] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  // ✅ Fetch videos from backend
  useEffect(() => {
    const fetchVideos = async () => {
      try {
        const res = await api.get("/media/get/all", {
          params: { type: "VIDEO_GALLERY" },
        });
        setGalleryVideos(res.data.map((item) => item.url));
      } catch (err) {
        console.error("Error fetching videos:", err);
      }
    };
    fetchVideos();
  }, []);

  const openLightbox = (index) => {
    setSelectedVideo(galleryVideos[index]);
    setCurrentIndex(index);
  };

  const closeLightbox = () => setSelectedVideo(null);

  const navigateVideo = (direction) => {
    let newIndex;
    if (direction === "prev") {
      newIndex =
        (currentIndex - 1 + galleryVideos.length) % galleryVideos.length;
    } else {
      newIndex = (currentIndex + 1) % galleryVideos.length;
    }
    setCurrentIndex(newIndex);
    setSelectedVideo(galleryVideos[newIndex]);
  };

  return (
    <section className="py-16 px-4 md:px-20 bg-white">
      <h2 className="text-3xl font-bold text-center mb-12 uppercase">
        RGCC Video Gallery
      </h2>

      {/* ✅ Grid stays same */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
        {galleryVideos.map((videoUrl, index) => (
          <div
            key={index}
            className="relative group cursor-pointer"
            onClick={() => openLightbox(index)}
          >
            <video
              src={videoUrl}
              muted
              loop
              playsInline
              className="w-full rounded-lg object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 flex items-center justify-center bg-black bg-opacity-20 group-hover:bg-opacity-40 transition-all duration-300 rounded-lg">
              <svg
                className="w-16 h-16 text-white opacity-90"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M14.752 11.168l-6.518-3.758A1 1 0 007 8.242v7.516a1 1 0 001.234.97l6.518-3.758a1 1 0 000-1.742z"
                />
              </svg>
            </div>
          </div>
        ))}
      </div>

      {/* ✅ Lightbox same */}
      {selectedVideo && (
        <div className="fixed inset-0 bg-black bg-opacity-90 z-50 flex items-center justify-center p-4">
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 text-white text-4xl hover:text-gray-300 transition-colors"
          >
            &times;
          </button>

          <button
            onClick={() => navigateVideo("prev")}
            className="absolute left-4 md:left-10 text-white text-4xl hover:text-gray-300 transition-colors"
          >
            &#10094;
          </button>

          <div className="max-w-4xl w-full">
            <video
              src={selectedVideo}
              controls
              autoPlay
              className="w-full max-h-[80vh] object-contain rounded-md"
            />
          </div>

          <button
            onClick={() => navigateVideo("next")}
            className="absolute right-4 md:right-10 text-white text-4xl hover:text-gray-300 transition-colors"
          >
            &#10095;
          </button>

          <div className="absolute bottom-4 text-white select-none">
            {currentIndex + 1} / {galleryVideos.length}
          </div>
        </div>
      )}
    </section>
  );
};

export default VideoGallery;
